export class ReceptionContactDetail {
  public isRequired: boolean;
  public contacts: string;
  public contactName: string;

  clone(): ReceptionContactDetail {
    const newObj = new ReceptionContactDetail();
    newObj.isRequired = this.isRequired;
    newObj.contacts = this.contacts;
    newObj.contactName = this.contactName;

    return newObj;
  }
}
